import { createStyles } from '@mantine/core'

export default createStyles(() => {
  return {
    avatar: {
      position: 'relative',
      borderTopLeftRadius: 'inherit',
      //   ...(display === 'vertical'
      //     ? {
      //         borderTopRightRadius: 'inherit',
      //       }
      //     : {
      //         borderBottomLeftRadius: 'inherit',
      //         width: rem(240),
      //         height: rem(240),
      //       }),
    },
  }
})
